export type Enquiry = { name: string; email: string; process: string; tools: string; botcheck: boolean };
// Web3Forms access keys are public form identifiers, not private API credentials.
const accessKey = import.meta.env.VITE_WEB3FORMS_ACCESS_KEY || '248d7cbe-2d2a-435f-aaab-a619c5a78b92';

export async function submitEnquiry(data: Enquiry, send: typeof fetch = fetch, timeoutMs = 15000): Promise<void> {
  if (data.botcheck) throw new Error('Please try again.');
  if (!data.name.trim() || !data.process.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email.trim())) {
    throw new Error('Please add your name, a valid email and a workflow.');
  }
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), timeoutMs);
  try {
    const response = await send('https://api.web3forms.com/submit', {
      method: 'POST', signal: controller.signal,
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ access_key: accessKey, subject: 'AutomateHQ — demo enquiry', from_name: 'AutomateHQ website',
        name: data.name.trim(), email: data.email.trim(), replyto: data.email.trim(), botcheck: false,
        message: `Demo enquiry\nWorkflow: ${data.process.trim()}\nTools: ${data.tools.trim() || 'Not specified'}` }),
    });
    const result = await response.json();
    if (!response.ok || result?.success !== true) throw new Error('Submission not confirmed');
  } catch {
    throw new Error('We could not confirm your enquiry was sent. Your details are still here. Please check your connection and try again.');
  } finally { clearTimeout(timeout); }
}
